import { render, staticRenderFns } from "./folderTree.vue?vue&type=template&id=597e7224&scoped=true&"
import script from "./folderTree.vue?vue&type=script&lang=js&"
export * from "./folderTree.vue?vue&type=script&lang=js&"
import style0 from "./folderTree.vue?vue&type=style&index=0&id=597e7224&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597e7224",
  null
  
)

export default component.exports